// Import controller interfaces
import {
    IRolesController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    PossibleProducerAgency,
    PossibleProducerAgent
} from '@app/models/api';

export default class MockRolesController implements IRolesController {

    public constructor() {

    }

    public async getPossibleProducerAgencies(): Promise<PossibleProducerAgency[]> {
        throw new Error("Method not implemented.");
    }

    public async getPossibleProducerAgents(producerAgencyId: number): Promise<PossibleProducerAgent[]> {
        throw new Error("Method not implemented.");
    }
};